// @flow
import initializers from '../dependencies/initializers'
import axios from 'axios'
export function usersCheckEmailApi(email: string) {
	return axios({
		url: initializers.recruiter_host+'/users/check-email',
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		// headers: {'X-Requested-With': 'XMLHttpRequest'},
		data: {
			email
		}
	})
}

export function usersSaveDataApi(data: Object) {
	return axios({
		url: initializers.recruiter_host+'/users',
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		// headers: {'X-Requested-With': 'XMLHttpRequest'},
		data
	})
}
